module.exports = __webpack_public_path__ + "media/components/print-link/static/icon-print-c4e159c28e30b1222d3ba2802eaed6e3.svg";